import React from 'react';
import { PatternFormat } from 'react-number-format';

const PhoneNumberFormat = React.forwardRef((props, ref) => {
  const { onChange, readOnly, ...other } = props;
  const inputRef = ref;

  if (props.readOnly != null && props.readOnly === true)
  {
    if (props.value == null || props.length === 0) {
      return (
        <span></span>
      );
    } else if (props.value[0] === '1' && props.value.length === 11) {
      return (
        <PatternFormat 
          {...props}
          displayType={'text'}
          format="+# (###) ###-####" mask="_"
        />
      );
    } else if (props.value.length === 10) {
      return (
        <PatternFormat 
          {...props}
          displayType={'text'}
          format="+1 (###) ###-####" mask="_"
        />
      );
    } else {
      return (
        <span>{props.value}</span>
      );
    }
  }
  else
  {
    return (
      <PatternFormat
        {...other}
        getInputRef={ inputRef }
        onValueChange={values => {
          onChange({
            target: {
              value: values.value,
            }
          })
        }}
        format="+1 (###) ###-####" mask="_"
      />
    );
  }
});

export default PhoneNumberFormat;
